import { Toast } from "@tandemdiabetes/sugarmate-react-components"
import { usePolyglot } from "src/contexts"

interface Props {
  id: string;
}

export function DeleteEntrySuccessToast(props: Props) {
  const polyglot = usePolyglot()

  return (
    <Toast
      stylePreset="success"
      body={polyglot.t("toasts.delete_entry_success.body")}
      id={props.id}
    />
  )
}
